import React from 'react';

import { useLagoon } from '../../../hooks/useLagoon';
import { ConstantsLagoon } from '../../ConstantsLagoon';
import { getFeatureFlag } from '../../Utils';
import {
  PreferencesForm as PreferencesFormV1,
  Props,
  RecommendationProp,
} from './PreferencesForm';
import { PreferencesFormV2 } from './PreferencesFormV2';

export type { Props, RecommendationProp };

/**
 * When ENABLE_IMPROVED_MEMBER_PREFERENCES flag is:
 * - OFF: Renders the current PreferencesForm  experience
 * - ON: Renders the new PreferencesFormV2 with:
 */
export const PreferencesForm = (props: Props) => {
  const featureFlags: [{ key: string; active: boolean }] =
    useLagoon('feature-flags')();
  const enableImprovedMemberPreferences: boolean = getFeatureFlag(
    featureFlags,
    ConstantsLagoon.FEATURE_FLAGS.ENABLE_IMPROVED_MEMBER_PREFERENCES
  );

  if (enableImprovedMemberPreferences) {
    return <PreferencesFormV2 {...props} />;
  }

  return <PreferencesFormV1 {...props} />;
};
